export default __webpack_public_path__ + "bcf3eb3b1e34afb506f30b51d48bdcc1.png";